// src/App.tsx

import './App.css';
import { HashRouter, Route, Routes } from 'react-router-dom';
import Home from './components/home';
import Transaction from './components/transaction';
import Login from './components/login';
import { useEffect, useState } from 'react';
import Stat from './components/stat';
import Gateway from './components/gateway';
import Documentation from './components/api_doc/pay_in/payin_doc';
import PaymentLink from './components/link_payment';
import CreateLink from './components/create_link';

function App() {

  const [authData, setAuthData] = useState<any>(null);

  useEffect(() => {
    const saved = localStorage.getItem("authUser");
    const initialValue = saved !== null ? JSON.parse(saved) : null;
    setAuthData(initialValue);
  }, []);

  return (
    <HashRouter>
      <Routes>
        {authData !== null ? (
          <Route path="/" element={<Home />} >
            <Route path="/" element={<Transaction />} />
            <Route path="/docs" element={<Documentation />} />
            <Route path="/transactions" element={<Transaction />} />
            <Route path="/account" element={<Gateway />} />
            <Route path="/create-link" element={<CreateLink />} />
          </Route>
        ) : (
          <>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Login />} />
            <Route path="/*" element={<Login />} />
          </>
        )}

        {/* Route PaymentLink avec paramètre ReqId */}
        <Route path="/payment-link/:ReqId" element={<PaymentLink />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
